import { createApi } from "@reduxjs/toolkit/query/react";
import { QueryRequest} from "../../types/types";
import { baseQueryWithRefreshTokenHandler } from "../authFetchBaseQuery";

/**
 * API service for validating signature tokens and handling refresh tokens.
 * 
 * This service uses Redux Toolkit's `createApi` to define the API endpoints and their configurations.
 * It provides the `SwitchPaymentGatewaySlice` endpoint which sends a POST request to the API to validate a signature token.
 */
export const SwitchPaymentGateway = createApi({
    // The reducer path used to slice the state in Redux
    reducerPath: "SwitchPaymentGateway",
    
    // Custom base query handler to handle both the API requests and refresh token logic
    baseQuery: baseQueryWithRefreshTokenHandler,
    tagTypes: ['DealersData'],
    // Refetch data when component mounts or when arguments change
    refetchOnMountOrArgChange: true,
    // Define API endpoints and their configurations
    endpoints: (builder) => ({
    /**
     * 
     * This endpoint makes a POST request to the `Everest/query` endpoint
     * and expects the required data in the request body. Upon successful validation, 
     * 
     * @param everestRequest - The signature token string.
     * @returns The associated query data.
     */
    getDataFromEverest: builder.query({
        query: (everestRequest: QueryRequest) => {
            return {
                url: 'Everest/query',
                method: 'POST',
                body: JSON.stringify(everestRequest),
            };
        },
        providesTags: ['DealersData'],
      // Keep the data for a minimal time to reduce unnecessary re-fetching
        keepUnusedDataFor: 0,
    }),

    /**
     * 
     * This endpoint makes a POST request to the `Dealer/SwitchDealerGatewayToAdyen` endpoint
     * and expects the gateway to be switched to adyen, 
     * 
     * @param everestRequest - The signature token string.
     * @returns The associated query data.
     */
    switchDealerGateWayToAdyen: builder.mutation({
        query: (dealerId: number) => {
            return {
                url: 'Dealer/SwitchDealerGatewayToAdyen',
                method: 'POST',
                body: dealerId,
            };
        },
        invalidatesTags: ['DealersData']
    })
    }),
});

// Export the auto-generated hook from the `SwitchPaymentGateway` API slice
export const { useGetDataFromEverestQuery, useSwitchDealerGateWayToAdyenMutation } = SwitchPaymentGateway;
